/**
 * Settings Utility
 * Helper functions for accessing WordPress settings
 */

import type { WidgetConfig } from '../types';

/**
 * Get WordPress settings from window object
 * @returns WordPress settings object or empty object if not available
 */
export function getWordPressSettings(): Partial<WidgetConfig> {
  if (typeof window === 'undefined') {
    return {};
  }
  return (window as any).ai360smartsearchSettings || {};
}

/**
 * Get a specific setting value with fallback
 * @param path Dot-notation path to setting (e.g., 'results.minResults')
 * @param defaultValue Default value if setting is not found
 * @returns The setting value or default value
 */
export function getSetting<T>(path: string, defaultValue: T): T {
  const settings = getWordPressSettings();
  const keys = path.split('.');
  let value: any = settings;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return defaultValue;
    }
  }
  
  return value !== undefined ? value : defaultValue;
}
